import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Form, { InputType } from '../../lib/Formik';

import * as yup from 'yup';
import en from '../../lang/en-us';
import { connect, useDispatch } from 'react-redux';
import {
    LoginPayload,
    LOGIN_OTP_GENERATE_PAYLOAD,
    LOGIN_OTP_VERIFY_PAYLOAD,
    LOGIN_RESEND_OTP,
    REDIRECT_ACTION,
} from '../../redux-store/types/login';
import { FormikErrors, FormikHelpers, useFormik } from 'formik';
import {
    onGenerateLoginOTP,
    onLogin,
    onResendLoginOTP,
    onVerifyLoginOTP,
    forgotQuestionAnswerOtp,
} from '../../redux-store/actions/login';
import { Button, Dialog, Switch } from '@material-ui/core';
import AccessibleDialog from '../../lib/AccessibleDialog';
import { useEffect, useMemo, useState } from 'react';
import Captcha from './Captcha';
import { OtpField, ResendOtp, useTimer } from '../../lib/OtpField';
import { RouteComponentProps, useHistory } from 'react-router';
import { isMobileDevice, OTP_ACTIONS } from '../../utils/constants';
const {
    login: { form, headerLinks },
} = en;

const PASSWORD = 'off';
const OTP = 'on';

type LoginFormikState = {
    userId: string;
    password: string;
    otp: string[];
    remember: boolean;
    captcha: string | null;
    signInType: string;
    otpInfo: OTP_INFO | null;
};

type OTP_INFO = {
    otpRef: string;
    reqId: string;
};
interface LoginProps extends RouteComponentProps<any> {
    onLogin: (body: LoginPayload) => Promise<any>;
    onGenerateLoginOTP: (body: LOGIN_OTP_GENERATE_PAYLOAD) => Promise<any>;
    onVerifyLoginOTP: (body: LOGIN_OTP_VERIFY_PAYLOAD) => Promise<any>;
    onResendLoginOTP: (body: LOGIN_RESEND_OTP) => Promise<any>;
    forgotQuestionAnswerOtp: (body: any) => Promise<any>;
}

const Remember = ({ value, ...props }: any) => {
    return (
        <div className="remember-forgot">
            {/* <FormControlLabel
                control={<Checkbox checked={props.value} />}
                label={form.rememberMe.label}
                {...props}
            /> */}
            <a
                href="/investor/forgot-password"
                role="link"
                tabIndex={0}
                aria-label="Forgot Password"
                className="forgot-password-btn"
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        props.history.push('/investor/forgot-password');
                    }
                }}
            >
                {form.action.href.forgotPassword.label}
            </a>
        </div>
    );
};

const TermsText = () => {
    const history = useHistory();
    return (
        <p className="terms-text">
            {form.termstext}{' '}
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    isMobileDevice()
                        ? history.push('/links/terms-of-use')
                        : window.open(`/links/terms-of-use`, '_blank');
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        isMobileDevice()
                            ? history.push('/links/terms-of-use')
                            : window.open(`/links/terms-of-use`, '_blank');
                    }
                }}
                role="link"
            >
                {form.termsLink}
            </a>
            .
        </p>
    );
};

const initialValues: LoginFormikState = {
    userId: '',
    password: '',
    remember: false,
    captcha: null,
    otp: new Array(6).fill(''),
    signInType: PASSWORD,
    otpInfo: null,
};

const validationSchema = yup.object({
    userId: yup
        .string()
        .required(form.panOrPekrn.validation.emptyError)
        .length(10, form.panOrPekrn.validation.minLengthError),
    // password: yup.string().required(form.password.validation.emptyError),
    // captcha: yup.string().required('Captcha is Required').nullable(),
});

export interface SwitchProps {
    value: 'off' | 'on';
}

const disableCaptcha = process.env.REACT_APP_TESTING === 'true';

const commonFields: Partial<InputType>[] = disableCaptcha
    ? [
          {
              component: TermsText,
              name: 'termsText',
          },
      ]
    : [
          {
              component: Captcha,
              name: 'captcha',
          },
          {
              component: TermsText,
              name: 'termsText',
          },
      ];

const userIDWithPanFields: Partial<InputType>[] = [
    {
        label: form.panOrPekrn.label,
        name: 'userId',
        type: 'text',
    },
    {
        component: ToggleTabs,
        name: 'signInType',
    },
];

const OtpScreen = ({
    formik,
    ...props
}: {
    formik: {
        initialValues: LoginFormikState;
        values: LoginFormikState;
        setValues: (
            values: React.SetStateAction<LoginFormikState>,
            shouldValidate?: boolean | undefined,
        ) => Promise<FormikErrors<LoginFormikState>> | Promise<void>;
        setFieldValue: (
            field: string,
            value: any,
            shouldValidate?: boolean | undefined,
        ) => Promise<FormikErrors<LoginFormikState>> | Promise<void>;
    };
}) => {
    const { timer, startTimer, stopTimer, resetTimer } = useTimer({});
    const dispatch = useDispatch();
    const { otpInfo } = formik.values;
    const onResend = async () => {
        try {
            let res: any = await dispatch(
                onResendLoginOTP({
                    reqId: otpInfo?.reqId || '',
                    action: 'OTP_LOGIN',
                    otpRef: otpInfo?.otpRef || '',
                }),
            );
            formik.setFieldValue('otpInfo', { ...res?.body });
            formik.setFieldValue('otp', new Array(6).fill(''));
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    useEffect(() => {
        return () => {
            stopTimer();
        };
    }, []);

    return (
        <div style={{ marginBottom: 10 }}>
            <OtpField {...props} formik={formik} />

            <ResendOtp counter={timer} startTimer={startTimer} onResendOtp={onResend} />
        </div>
    );
};

const OTP_FIELD: Partial<InputType> = {
    component: OtpScreen,
    name: 'otp',
};

const loginWithOTP: Partial<InputType>[] = [...userIDWithPanFields];

function ToggleTabs({
    formik,
}: {
    formik: {
        initialValues: LoginFormikState;
        values: LoginFormikState;
        setValues: (
            values: React.SetStateAction<LoginFormikState>,
            shouldValidate?: boolean | undefined,
        ) => Promise<FormikErrors<LoginFormikState>> | Promise<void>;
    };
}) {
    const { signInType } = formik.values;

    const switchTabs = (e: any) => {
        formik.setValues({
            ...formik.initialValues,
            signInType: e.target.checked ? OTP : PASSWORD,
            userId: formik.values.userId,
            otp: new Array(6).fill(''),
        });
    };

    return (
        <div className="toggle-tabs">
            <a
                onClick={() => switchTabs({ target: { checked: false } })}
                className={signInType === PASSWORD ? 'active' : ''}
            >
                Password
            </a>
            <div className="toggle">
                <Switch
                    checked={signInType === PASSWORD ? false : true}
                    value={signInType}
                    onChange={switchTabs}
                    name="signInToggle"
                    inputProps={{ 'aria-label': 'toggleSwitch' }}
                />
            </div>
            <a
                onClick={() => switchTabs({ target: { checked: true } })}
                className={signInType === PASSWORD ? '' : 'active'}
            >
                OTP
            </a>
        </div>
    );
}

function Login(props: LoginProps) {
    const [show, setShow] = useState(false);
    const [userId, setUserId] = useState('');
    const history = useHistory();
    const dispatch = useDispatch();
    const handleResetQuestions = async () => {
        const requestData = {
            mobile: '',
            pekrn: '',
            pan: '',
            email: '',
            userId: userId,
        };
        try {
            let res = await props.forgotQuestionAnswerOtp({
                ...requestData,
            });
            props.history.push('/investor/reset-question-otp', {
                // ...props.location.state,
                pan: userId,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };
    const onSubmit = async (values: LoginFormikState, action: FormikHelpers<LoginFormikState>) => {
        const { userId, otpInfo, signInType, otp } = values;
        if (!otpInfo && signInType === OTP) {
            try {
                let res = await props.onGenerateLoginOTP({
                    userId: userId.toUpperCase(),
                    action: 'OTP_LOGIN',
                });
                formik.setFieldValue('otpInfo', res?.body);
                formik.setSubmitting(false);
            } catch (err: any) {
                alert(err.message);
            }
            return;
        }
        const panPayload: LoginPayload = {
            userId: userId.toUpperCase(),
            password: values.password,
        };
        const otpPayload: LOGIN_OTP_VERIFY_PAYLOAD = {
            userId: userId.toUpperCase(),
            enteredOtp: otp.join(''),
            otpRef: otpInfo?.otpRef || '',
            reqId: otpInfo?.reqId || '',
            action: 'OTP_LOGIN',
        };
        try {
            if (signInType === PASSWORD) {
                let res = await props.onLogin(panPayload);
                if (!res.body.data.length) {
                    setUserId(res.body.pan);
                    setShow(true);
                    return;
                }
                props.history.push('signin-questionnaire', {
                    ...(res || {}).body,
                    action: OTP_ACTIONS.login,
                });
            } else {
                const { enteredOtp } = otpPayload;
                if (enteredOtp.length < 6) {
                    formik.setErrors({ otp: 'OTP required' });
                    return;
                }
                if (!values.captcha && values.otpInfo && !disableCaptcha) {
                    formik.setErrors({ captcha: 'Captcha required' });
                    return;
                }
                let res = await props.onVerifyLoginOTP(otpPayload);
                if (!res.body.data.length) {
                    setUserId(res.body.pan);
                    setShow(true);
                    return;
                }
                props.history.push('signin-questionnaire', {
                    ...(res || {}).body,
                    action: OTP_ACTIONS.otp_login,
                });
            }
        } catch (err: any) {
            alert(err.message);
        }
        action.setSubmitting(false);
    };

    const validate = (values: LoginFormikState) => {
        if (values.signInType === PASSWORD) {
            if (!values.password) {
                return { password: form.password.validation.emptyError };
            }
            if (!values.captcha && !disableCaptcha) {
                return { captcha: 'Captcha required' };
            }
        }
    };

    const loginWithPan = useMemo((): Partial<InputType>[] => {
        return [
            ...userIDWithPanFields,
            {
                label: form.password.label,
                type: 'password',
                name: 'password',
            },
            {
                component: Remember,
                name: 'remember',
                extraProps: { history: props.history },
            },
            ...commonFields,
        ];
    }, [props.history]);

    const formik = useFormik<LoginFormikState>({
        initialValues,
        onSubmit,
        validationSchema,
        initialStatus: false,
        validateOnMount: false,
        validate,
    });

    useEffect(() => {
        formik.setValues({ ...formik.values, otpInfo: null, captcha: null });
    }, [formik.values.userId]);
    useEffect(() => {
        if (props.location.state) {
            const { referrer = null, searchParams = null } = props.location.state as any;
            dispatch({
                type: REDIRECT_ACTION,
                body: {
                    redirectPath: !!searchParams ? `${referrer}${searchParams}` : referrer,
                    isLoggedOut: false,
                },
            });
        }
    }, []);
    return (
        <>
            <h3 className="text-center">{headerLinks.link2}</h3>
            <Form
                ui={
                    formik.values.signInType === PASSWORD
                        ? loginWithPan
                        : formik.values.otpInfo
                        ? [...loginWithOTP, OTP_FIELD, ...commonFields]
                        : loginWithOTP
                }
                submitButtonLabel={
                    formik.values.signInType === PASSWORD
                        ? form.action.button.label
                        : !formik.values.otpInfo
                        ? `Generate OTP`
                        : form.action.button.verifyOtp
                }
                formik={formik}
            ></Form>
            <AccessibleDialog
                maxWidth={'sm'}
                open={show}
                aria-labelledby="note-modals"
                onClose={() => setShow(false)}
            >
                <div className="note-modals">
                    <h3 id="note-modals">Reset Security Questions</h3>
                    <p>
                        Dear Investor, we are unable to proceed due to technical glitch. Please
                        reset your security questions to login smoothly. We regret inconvenience
                        caused.
                    </p>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn"
                            onClick={() => {
                                setShow(false);
                                handleResetQuestions();
                            }}
                        >
                            OK
                        </Button>
                        <Button
                            className="customBtn cancelBtn"
                            onClick={() => {
                                setShow(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </AccessibleDialog>
        </>
    );
}
export default connect(null, {
    onLogin,
    onGenerateLoginOTP,
    forgotQuestionAnswerOtp,
    onResendLoginOTP,
    onVerifyLoginOTP,
})(Login);
